/* ============================================================
   androidInspect.js — logik "tunjuk elemen" (Inspector admin + nanti mod
   "Ajar robot" pelanggan). TULEN: tiada React, tiada ADB — terima hasil
   bacaan skrin (bacaSkrin dalam androidDumpKit) dan titik ketukan.
   ============================================================
   Keputusan user 4 Nov 2026: Inspector macam GenFarmer untuk admin dahulu;
   kemudian "Ajar robot" untuk pelanggan memakai logik yang SAMA (elementAt +
   cadangSelector) supaya apa yang admin nampak = apa yang robot simpan.
   ============================================================ */

const luas = (b) => Math.max(1, (b.x2 - b.x1) * (b.y2 - b.y1));
const dalam = (b, x, y) => x >= b.x1 && x <= b.x2 && y >= b.y1 && y <= b.y2;

// Elemen PALING KECIL yang mengandungi titik (x,y) — itu yang mata nampak ditekan.
// utamakanBermakna: pilih yang ada teks/desc/id/boleh klik bila ada (bekas kosong dilangkau).
export function elementAt(els, x, y, { utamakanBermakna = true } = {}) {
  const kena = (els || []).filter((e) => e.b && dalam(e.b, x, y)).sort((a, b) => luas(a.b) - luas(b.b));
  if (!kena.length) return null;
  if (!utamakanBermakna) return kena[0];
  return kena.find((e) => e.text || e.desc || e.id || e.clickable) || kena[0];
}

// Elemen boleh-klik terdekat yang membungkus elemen ini (butang sebenar selalunya induk teks).
export function klikPembungkus(els, el) {
  if (!el?.b) return null;
  if (el.clickable) return el;
  return (els || [])
    .filter((e) => e.clickable && e.b && e.b.x1 <= el.b.x1 && e.b.y1 <= el.b.y1 && e.b.x2 >= el.b.x2 && e.b.y2 >= el.b.y2)
    .sort((a, b) => luas(a.b) - luas(b.b))[0] || null;
}

const kira = (els, f) => (els || []).filter(f).length;

/* Cadangan cara robot mengenal elemen ini, paling stabil dahulu:
   content-desc unik → teks unik → resource-id unik → gabungan id+teks → kedudukan (nisbah).
   Pulang { jenis, nilai, unik, nota } — `unik` = bilangan padanan pada skrin ini. */
export function cadangSelector(el, els, skrin = { w: 720, h: 1640 }) {
  if (!el) return null;
  const pilihan = [];
  if (el.desc) pilihan.push({ jenis: 'desc', nilai: el.desc, unik: kira(els, (e) => e.desc === el.desc) });
  if (el.text) pilihan.push({ jenis: 'text', nilai: el.text, unik: kira(els, (e) => e.text === el.text) });
  if (el.id) pilihan.push({ jenis: 'id', nilai: el.id, unik: kira(els, (e) => e.id === el.id), nota: 'resource-id boleh berubah bila app dikemas kini' });
  if (el.id && el.text) pilihan.push({ jenis: 'id+text', nilai: { id: el.id, text: el.text }, unik: kira(els, (e) => e.id === el.id && e.text === el.text) });
  const terbaik = pilihan.find((p) => p.unik === 1 && p.jenis !== 'id') || pilihan.find((p) => p.unik === 1);
  if (terbaik) return terbaik;
  const cx = (el.b.x1 + el.b.x2) / 2; const cy = (el.b.y1 + el.b.y2) / 2;
  return {
    jenis: 'ratio',
    nilai: { rx: +(cx / (skrin.w || 720)).toFixed(4), ry: +(cy / (skrin.h || 1640)).toFixed(4) },
    unik: 0,
    nota: 'Tiada nama unik — guna kedudukan (rapuh bila skrin berbeza)',
  };
}

// Laluan ringkas ikut class + kedudukan (paparan sahaja, macam "XPathLite" GenFarmer).
export function laluanRingkas(el) {
  if (!el) return '';
  return `//${el.cls || 'node'}${el.id ? `[@resource-id="${el.id}"]` : ''}${el.text ? `[@text="${el.text}"]` : ''}${el.desc ? `[@content-desc="${el.desc}"]` : ''}`;
}

export function cariElemen(els, kata, { klikSahaja = false } = {}) {
  const q = String(kata || '').trim().toLowerCase();
  return (els || []).filter((e) => {
    if (klikSahaja && !e.clickable) return false;
    if (!q) return !!(e.text || e.desc || e.id || e.clickable);
    return [e.text, e.desc, e.id, e.cls].some((v) => String(v || '').toLowerCase().includes(q));
  });
}
